import clsx from 'clsx';

const STATUS_STYLES: Record<string, { label: string; className: string }> = {
  expected: { label: 'expected', className: 'bg-muted/20 text-muted' },
  logged:   { label: 'logged',   className: 'bg-amber-100 text-amber-700' },
  reconciled: { label: 'reconciled', className: 'bg-green-100 text-green-700' },
  disputed:   { label: 'disputed',   className: 'bg-red-100 text-red-700' },
  cancelled:  { label: 'cancelled',  className: 'bg-muted/10 text-muted line-through' },
};

export function PaymentStatusBadge({ status }: { status: string }) {
  const s = STATUS_STYLES[status] ?? { label: status, className: 'bg-muted/20 text-muted' };
  return <span className={clsx('inline-flex items-center px-1.5 py-0.5 rounded text-[11px] font-medium leading-none', s.className)}>{s.label}</span>;
}
